import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";

const ProtectedRoute = ({ children }) => {
  const formfilled = useSelector((state) => state.form.formfilled);
  const userId = useSelector((state) => state.user?.user_id);
  const location = useLocation();
  const hasMounted = useRef(false);

  useEffect(() => {
    if (!formfilled && hasMounted.current) {
      toast.error("Please fill out the form first!", { duration: 2000 });
    } else {
      hasMounted.current = true;
    }
  }, [formfilled, location.pathname]);


  // If not authenticated, redirect to login
  if (!userId) {
    if (location.pathname !== "/") {
      return <Navigate to="/" replace />;
    }
  }

  // If authenticated but form not filled, redirect to home (except on home)
  if (!formfilled) {
    if (location.pathname !== "/home") {
      return <Navigate to="/home" replace />;
    }
  }

  return children;
};
export default ProtectedRoute;